import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "area_section"
}
const _hoisted_2 = { class: "area_contents" }
const _hoisted_3 = { class: "area_contents_body" }
const _hoisted_4 = { class: "areaGrid" }
const _hoisted_5 = { class: "last_line" }
const _hoisted_6 = { class: "last_line" }
const _hoisted_7 = { class: "last_line" }
const _hoisted_8 = { class: "area_contents" }
const _hoisted_9 = { class: "area_contents_body" }
const _hoisted_10 = { class: "areaGrid" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "area_contents" }
const _hoisted_16 = { class: "area_contents_body" }
const _hoisted_17 = { class: "areaGrid" }
const _hoisted_18 = { class: "area_contents" }
const _hoisted_19 = { class: "area_contents_body" }
const _hoisted_20 = { class: "areaGrid" }
const _hoisted_21 = { class: "area_contents" }
const _hoisted_22 = { class: "area_contents_body" }
const _hoisted_23 = { class: "areaGrid" }
const _hoisted_24 = { class: "area_contents" }
const _hoisted_25 = { class: "area_contents_body" }
const _hoisted_26 = { class: "areaGrid" }
const _hoisted_27 = { class: "area_contents" }
const _hoisted_28 = { class: "area_contents_body" }
const _hoisted_29 = { class: "areaGrid" }
const _hoisted_30 = { class: "area_contents" }
const _hoisted_31 = { class: "area_contents_body" }
const _hoisted_32 = { class: "areaGrid" }
const _hoisted_33 = { class: "area_contents" }
const _hoisted_34 = { class: "area_contents_body" }
const _hoisted_35 = { class: "areaGrid" }
const _hoisted_36 = { class: "area_contents" }
const _hoisted_37 = { class: "area_contents_body" }
const _hoisted_38 = { class: "areaGrid" }
const _hoisted_39 = { class: "area_contents" }
const _hoisted_40 = { class: "area_contents_body" }
const _hoisted_41 = { class: "areaGrid" }
const _hoisted_42 = { class: "area_contents" }
const _hoisted_43 = { class: "area_contents_body" }
const _hoisted_44 = { class: "areaGrid" }
const _hoisted_45 = {
  scope: "col",
  id: "last_td"
}
const _hoisted_46 = {
  scope: "col",
  id: "last_td"
}
const _hoisted_47 = { class: "area_contents" }
const _hoisted_48 = { class: "area_contents_body" }
const _hoisted_49 = { class: "areaGrid" }
const _hoisted_50 = { class: "area_contents" }
const _hoisted_51 = { class: "area_contents_body" }
const _hoisted_52 = { class: "areaGrid" }
const _hoisted_53 = { class: "area_contents" }
const _hoisted_54 = { class: "area_contents_body" }
const _hoisted_55 = { class: "areaGrid" }
const _hoisted_56 = { class: "area_contents" }
const _hoisted_57 = { class: "area_contents_body" }
const _hoisted_58 = { class: "areaGrid" }
const _hoisted_59 = { class: "area_contents" }
const _hoisted_60 = { class: "area_contents_body" }
const _hoisted_61 = { class: "areaGrid" }
const _hoisted_62 = { class: "area_contents" }
const _hoisted_63 = { class: "area_contents_body" }
const _hoisted_64 = { class: "areaGrid" }
const _hoisted_65 = { class: "area_contents" }
const _hoisted_66 = { class: "area_contents_body" }
const _hoisted_67 = { class: "areaGrid" }
const _hoisted_68 = { class: "area_contents" }
const _hoisted_69 = { class: "area_contents_body" }
const _hoisted_70 = { class: "areaGrid" }
const _hoisted_71 = { class: "area_contents" }
const _hoisted_72 = { class: "area_contents_body" }
const _hoisted_73 = { class: "areaGrid" }
const _hoisted_74 = { class: "area_contents" }
const _hoisted_75 = { class: "area_contents_body" }
const _hoisted_76 = { class: "areaGrid" }
const _hoisted_77 = { class: "area_contents" }
const _hoisted_78 = { class: "area_contents_body" }
const _hoisted_79 = { class: "areaGrid" }
const _hoisted_80 = { class: "area_contents" }
const _hoisted_81 = { class: "area_contents_body" }
const _hoisted_82 = { class: "areaGrid" }
const _hoisted_83 = { class: "area_contents" }
const _hoisted_84 = { class: "area_contents_body" }
const _hoisted_85 = { class: "areaGrid" }
const _hoisted_86 = { class: "last_line" }
const _hoisted_87 = { class: "last_line" }
const _hoisted_88 = { class: "last_line" }
const _hoisted_89 = { class: "last_line" }
const _hoisted_90 = { class: "last_line" }
const _hoisted_91 = { class: "area_contents" }
const _hoisted_92 = { class: "area_contents_body" }
const _hoisted_93 = { class: "areaGrid" }
const _hoisted_94 = { class: "last_line" }
const _hoisted_95 = { class: "last_line" }
const _hoisted_96 = { class: "last_line" }
const _hoisted_97 = { class: "last_line" }
const _hoisted_98 = { class: "last_line" }
const _hoisted_99 = { class: "last_line" }
const _hoisted_100 = { class: "area_contents" }
const _hoisted_101 = { class: "area_contents_body" }
const _hoisted_102 = { class: "areaGrid" }
const _hoisted_103 = { class: "last_line" }
const _hoisted_104 = { class: "last_line" }
const _hoisted_105 = { class: "last_line" }
const _hoisted_106 = { class: "last_line" }
const _hoisted_107 = { class: "area_contents" }
const _hoisted_108 = { class: "area_contents_body" }
const _hoisted_109 = { class: "areaGrid" }
const _hoisted_110 = { class: "last_line" }
const _hoisted_111 = { class: "last_line" }
const _hoisted_112 = { class: "last_line" }
const _hoisted_113 = { class: "last_line" }
const _hoisted_114 = { class: "last_line" }
const _hoisted_115 = { class: "last_line" }
const _hoisted_116 = { class: "last_line" }
const _hoisted_117 = { class: "area_contents" }
const _hoisted_118 = { class: "area_contents_body" }
const _hoisted_119 = { class: "areaGrid" }
const _hoisted_120 = { class: "last_line" }
const _hoisted_121 = { class: "last_line" }
const _hoisted_122 = { class: "last_line" }
const _hoisted_123 = { class: "last_line" }
const _hoisted_124 = { class: "last_line" }
const _hoisted_125 = { class: "last_line" }
const _hoisted_126 = { class: "last_line" }
const _hoisted_127 = { class: "last_line" }
const _hoisted_128 = { class: "last_line" }
const _hoisted_129 = { class: "last_line" }
const _hoisted_130 = { class: "last_line" }
const _hoisted_131 = { class: "last_line" }
const _hoisted_132 = { class: "area_contents" }
const _hoisted_133 = { class: "area_contents_body" }
const _hoisted_134 = { class: "areaGrid" }
const _hoisted_135 = { class: "last_line" }
const _hoisted_136 = { class: "last_line" }
const _hoisted_137 = { class: "last_line" }
const _hoisted_138 = { class: "last_line" }
const _hoisted_139 = { class: "last_line" }
const _hoisted_140 = { class: "last_line" }
const _hoisted_141 = { class: "last_line" }
const _hoisted_142 = { class: "last_line" }
const _hoisted_143 = { class: "last_line" }
const _hoisted_144 = { class: "last_line" }
const _hoisted_145 = { class: "last_line" }
const _hoisted_146 = { class: "last_line" }
const _hoisted_147 = { class: "area_contents" }
const _hoisted_148 = { class: "area_contents_body" }
const _hoisted_149 = { class: "areaGrid" }
const _hoisted_150 = { class: "last_line" }
const _hoisted_151 = { class: "last_line" }
const _hoisted_152 = { class: "last_line" }
const _hoisted_153 = { class: "last_line" }
const _hoisted_154 = { class: "last_line" }
const _hoisted_155 = { class: "last_line" }
const _hoisted_156 = { class: "area_contents" }
const _hoisted_157 = { class: "area_contents_body" }
const _hoisted_158 = { class: "areaGrid" }
const _hoisted_159 = { class: "last_line" }
const _hoisted_160 = { class: "last_line" }
const _hoisted_161 = { class: "last_line" }
const _hoisted_162 = { class: "last_line" }
const _hoisted_163 = { class: "last_line" }
const _hoisted_164 = { class: "last_line" }
const _hoisted_165 = { class: "last_line" }
const _hoisted_166 = { class: "last_line" }
const _hoisted_167 = { class: "last_line" }
const _hoisted_168 = { class: "last_line" }
const _hoisted_169 = { class: "area_contents" }
const _hoisted_170 = { class: "area_contents_body" }
const _hoisted_171 = { class: "areaGrid" }
const _hoisted_172 = { class: "last_line" }
const _hoisted_173 = { class: "last_line" }
const _hoisted_174 = { class: "last_line" }
const _hoisted_175 = { class: "last_line" }
const _hoisted_176 = { class: "last_line" }
const _hoisted_177 = { class: "last_line" }
const _hoisted_178 = { class: "last_line" }
const _hoisted_179 = { class: "last_line" }
const _hoisted_180 = { class: "last_line" }
const _hoisted_181 = { class: "last_line" }
const _hoisted_182 = { class: "area_contents" }
const _hoisted_183 = { class: "area_contents_body" }
const _hoisted_184 = { class: "areaGrid" }
const _hoisted_185 = { class: "last_line" }
const _hoisted_186 = { class: "last_line" }
const _hoisted_187 = { class: "last_line" }
const _hoisted_188 = { class: "last_line" }
const _hoisted_189 = { class: "last_line" }
const _hoisted_190 = { class: "last_line" }
const _hoisted_191 = { class: "last_line" }
const _hoisted_192 = { class: "last_line" }
const _hoisted_193 = { class: "last_line" }
const _hoisted_194 = { class: "last_line" }
const _hoisted_195 = { class: "last_line" }
const _hoisted_196 = { class: "last_line" }
const _hoisted_197 = { class: "last_line" }
const _hoisted_198 = { class: "last_line" }
const _hoisted_199 = { class: "last_line" }
const _hoisted_200 = { class: "last_line" }
const _hoisted_201 = { class: "last_line" }
const _hoisted_202 = { class: "area_contents" }
const _hoisted_203 = { class: "area_contents_body" }
const _hoisted_204 = { class: "areaGrid" }
const _hoisted_205 = { class: "last_line" }
const _hoisted_206 = { class: "last_line" }
const _hoisted_207 = { class: "last_line" }
const _hoisted_208 = { class: "last_line" }
const _hoisted_209 = { class: "last_line" }
const _hoisted_210 = { class: "last_line" }
const _hoisted_211 = { class: "last_line" }
const _hoisted_212 = { class: "last_line" }
const _hoisted_213 = { class: "last_line" }
const _hoisted_214 = { class: "last_line" }
const _hoisted_215 = { class: "last_line" }
const _hoisted_216 = { class: "area_contents" }
const _hoisted_217 = { class: "area_contents_body" }
const _hoisted_218 = {
  key: 0,
  class: "areaGrid"
}
const _hoisted_219 = { class: "last_line" }
const _hoisted_220 = { class: "last_line" }
const _hoisted_221 = { class: "last_line" }
const _hoisted_222 = { class: "last_line" }
const _hoisted_223 = { class: "last_line" }
const _hoisted_224 = { class: "last_line" }
const _hoisted_225 = { class: "last_line" }
const _hoisted_226 = { class: "last_line" }
const _hoisted_227 = { class: "last_line" }
const _hoisted_228 = { class: "last_line" }
const _hoisted_229 = {
  key: 1,
  class: "areaGrid"
}
const _hoisted_230 = { class: "last_line" }
const _hoisted_231 = { class: "last_line" }
const _hoisted_232 = { class: "last_line" }
const _hoisted_233 = { class: "last_line" }
const _hoisted_234 = { class: "last_line" }
const _hoisted_235 = { class: "last_line" }
const _hoisted_236 = { class: "last_line" }
const _hoisted_237 = { class: "last_line" }
const _hoisted_238 = { class: "last_line" }
const _hoisted_239 = { class: "last_line" }
const _hoisted_240 = { class: "last_line" }
const _hoisted_241 = { class: "last_line" }
const _hoisted_242 = { class: "last_line" }
const _hoisted_243 = { class: "last_line" }
const _hoisted_244 = { class: "last_line" }
const _hoisted_245 = { class: "last_line" }
const _hoisted_246 = { class: "area_contents" }
const _hoisted_247 = { class: "area_contents_body" }
const _hoisted_248 = { class: "areaGrid" }
const _hoisted_249 = { class: "" }
const _hoisted_250 = { class: "" }
const _hoisted_251 = { class: "" }
const _hoisted_252 = { class: "" }
const _hoisted_253 = { class: "" }
const _hoisted_254 = { class: "" }
const _hoisted_255 = { class: "" }
const _hoisted_256 = { class: "" }
const _hoisted_257 = { class: "" }
const _hoisted_258 = { class: "" }
const _hoisted_259 = { class: "" }
const _hoisted_260 = { class: "last_line" }
const _hoisted_261 = {
  key: 1,
  class: "area_section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.state.data != null && $setup.state.data.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "실인원")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "등록된 총 내담자"),
                  _createElementVNode("th", { scope: "col" }, "실인원"),
                  _createElementVNode("th", { scope: "col" }, "실인원 비율(%)")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(998, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_6, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(999, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(Math.round(($setup.CommonUtils.getCntByCn(999, $setup.state.data) / $setup.CommonUtils.getCntByCn(998, $setup.state.data)) * 10000) / 100 +
                                    "(%)"), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "상담유형")
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("th", null, "전화상담", -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("th", null, "내방상담", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("th", null, "방문상담", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("th", null, "사이버", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("th", null, "서신", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("th", null, "아웃리치", -1)),
                  ($setup.state.sYear >= 2019)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_11, "온라인 상담"))
                    : _createCommentVNode("", true),
                  _cache[8] || (_cache[8] = _createElementVNode("th", null, "총합", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1, $setup.state.data) - $setup.CommonUtils.getCntByCn(56, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(2, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(3, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(5, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(95, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(6, $setup.state.data))), 1),
                  ($setup.state.sYear >= 2019)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(620, $setup.state.data))), 1))
                    : _createCommentVNode("", true),
                  ($setup.state.sYear >= 2019)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.CommonUtils.getCntByCn(1, $setup.state.data) -
                                                $setup.CommonUtils.getCntByCn(56, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(2, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(3, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(5, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(95, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(6, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(620, $setup.state.data),
                                        )), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.CommonUtils.getCntByCn(1, $setup.state.data) -
                                                $setup.CommonUtils.getCntByCn(56, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(2, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(3, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(5, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(95, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(6, $setup.state.data),
                                        )), 1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "상담대상자")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "본인"),
                  _createElementVNode("th", null, "가족/친인"),
                  _createElementVNode("th", null, "동료/이웃"),
                  _createElementVNode("th", null, "타기관"),
                  _createElementVNode("th", null, "성매매방지기관"),
                  _createElementVNode("th", null, "유관기관"),
                  _createElementVNode("th", null, "학교"),
                  _createElementVNode("th", null, "검찰/경찰/법원"),
                  _createElementVNode("th", null, "기타"),
                  _createElementVNode("th", null, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(122, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(127, $setup.state.data) -
                                            $setup.CommonUtils.getCntByCn(56, $setup.state.data),
                                    )), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(123, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(124, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(125, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(540, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(541, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(542, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(543, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(126, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(122, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(127, $setup.state.data) -
                                            $setup.CommonUtils.getCntByCn(56, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(123, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(124, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(125, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(540, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(541, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(542, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(543, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(126, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "상담내용")
          ], -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("table", _hoisted_20, [
              _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "탈성매매"),
                  _createElementVNode("th", null, "빚문제"),
                  _createElementVNode("th", null, "폭행"),
                  _createElementVNode("th", null, "진로(취업 등)"),
                  _createElementVNode("th", null, "사회적낙인"),
                  _createElementVNode("th", null, "건강의료문제"),
                  _createElementVNode("th", null, "경찰조사"),
                  _createElementVNode("th", null, "법률문제"),
                  _createElementVNode("th", null, "가족문제"),
                  _createElementVNode("th", null, "주거"),
                  _createElementVNode("th", null, "자활문제"),
                  _createElementVNode("th", null, "정서문제"),
                  _createElementVNode("th", null, "사각지대PG"),
                  _createElementVNode("th", null, "기타"),
                  _createElementVNode("th", null, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(36, $setup.state.data) + $setup.CommonUtils.getCntByCn(121, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(37, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(38, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(39, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(40, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(41, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(107, $setup.state.data),
                                    )), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(400, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(47, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(570, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(42, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(109, $setup.state.data),
                                    )), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(401, $setup.state.data) + $setup.CommonUtils.getCntByCn(45, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(402, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(44, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(48, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(108, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(46, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(49, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(120, $setup.state.data),
                                    )), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(403, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(43, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(563, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(725, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(726, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(50, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(36, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(37, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(38, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(39, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(40, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(41, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(42, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(43, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(563, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(725, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(44, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(45, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(46, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(47, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(48, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(49, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(50, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(107, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(109, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(108, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(120, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(121, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(400, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(401, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(402, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(403, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(570, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(726, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "상담조치결과")
          ], -1)),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("table", _hoisted_23, [
              _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "정서적지원"),
                  _createElementVNode("th", null, "법률지원"),
                  _createElementVNode("th", null, "의료지원"),
                  _createElementVNode("th", null, "자활지원"),
                  _createElementVNode("th", null, "집단프로그램"),
                  _createElementVNode("th", null, "물적자원"),
                  _createElementVNode("th", null, "심리지원"),
                  _createElementVNode("th", null, "관련기관연계"),
                  _createElementVNode("th", null, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(51, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(55, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(54, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(103, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(404, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(405, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(406, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(52, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(51, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(52, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(54, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(55, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(103, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(404, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(405, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(406, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원제공 > 정서지원")
          ], -1)),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "구분"),
                  _createElementVNode("th", null, "일상생활상담"),
                  _createElementVNode("th", null, "가족문제상담"),
                  _createElementVNode("th", null, "경제문제상담"),
                  _createElementVNode("th", null, "정보제공"),
                  _createElementVNode("th", null, "타기관 상담의뢰"),
                  _createElementVNode("th", null, "사부작공방 관련"),
                  _createElementVNode("th", null, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(133, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(134, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(135, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(769, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(727, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(800, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(133, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(134, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(135, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(769, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(727, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(800, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[17] || (_cache[17] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(413, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(414, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(415, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(728, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(729, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(801, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(413, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(414, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(415, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(728, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(729, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(801, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원제공 > 정서지원 > 정보제공")
          ], -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("table", _hoisted_29, [
              _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "구분"),
                  _createElementVNode("th", null, "경찰·검찰·법원"),
                  _createElementVNode("th", null, "성매매방지기관"),
                  _createElementVNode("th", null, "전문상담기관"),
                  _createElementVNode("th", null, "직업훈련·알선기관"),
                  _createElementVNode("th", null, "1366·1388 등"),
                  _createElementVNode("th", null, "학교·대안교육기관"),
                  _createElementVNode("th", null, "기타"),
                  _createElementVNode("th", null, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("td", null, "총 실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(810, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(811, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(812, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(813, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(814, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(815, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(816, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(810, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(811, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(812, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(813, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(814, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(815, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(816, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[21] || (_cache[21] = _createElementVNode("td", null, "구조지원 실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(818, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(819, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(820, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(821, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(822, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(823, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(824, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(818, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(819, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(820, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(821, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(822, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(823, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(824, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원제공 > 정서지원 > 타기관 상담의뢰")
          ], -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("table", _hoisted_32, [
              _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "구분"),
                  _createElementVNode("th", null, "경찰·검찰·법원"),
                  _createElementVNode("th", null, "성매매방지기관"),
                  _createElementVNode("th", null, "전문상담기관"),
                  _createElementVNode("th", null, "직업훈련·알선기관"),
                  _createElementVNode("th", null, "1366·1388 등"),
                  _createElementVNode("th", null, "학교·대안교육기관"),
                  _createElementVNode("th", null, "기타"),
                  _createElementVNode("th", null, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[24] || (_cache[24] = _createElementVNode("td", null, "총 실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(730, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(731, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(732, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(733, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(734, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(735, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(736, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(730, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(731, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(732, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(733, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(734, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(735, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(736, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[25] || (_cache[25] = _createElementVNode("td", null, "구조지원 실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(738, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(739, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(740, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(741, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(742, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(743, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(744, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(738, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(739, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(740, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(741, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(742, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(743, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(744, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "법률지원")
          ], -1)),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("table", _hoisted_35, [
              _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "구분"),
                  _createElementVNode("th", { scope: "col" }, "법률상담"),
                  _createElementVNode("th", { scope: "col" }, "수사동행(경찰)"),
                  _createElementVNode("th", { scope: "col" }, "수사동행(검찰)"),
                  _createElementVNode("th", { scope: "col" }, "수사의뢰"),
                  _createElementVNode("th", { scope: "col" }, "현장구조"),
                  _createElementVNode("th", { scope: "col" }, "소년보호"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", { scope: "col" }, "수사지원"),
                  _createElementVNode("th", { scope: "col" }, "소송지원"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[28] || (_cache[28] = _createElementVNode("td", null, "총 실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(136, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(626, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(627, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(139, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(557, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(628, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(629, $setup.state.data) + $setup.CommonUtils.getCntByCn(141, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(630, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(631, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(136, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(626, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(627, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(139, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(557, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(628, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(629, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(141, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(630, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(631, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[29] || (_cache[29] = _createElementVNode("td", null, "구조지원 실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(416, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(671, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(672, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(421, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(558, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(673, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(674, $setup.state.data) + $setup.CommonUtils.getCntByCn(423, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(675, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(676, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(416, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(671, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(672, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(421, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(558, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(673, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(674, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(423, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(675, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(676, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "법률지원 > 수사지원 > 기소,피소")
          ], -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("table", _hoisted_38, [
              _cache[35] || (_cache[35] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "2"
                  }, "구분"),
                  _createElementVNode("th", { width: "15%" }, "기소"),
                  _createElementVNode("th", { width: "15%" }, "피소"),
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[32] || (_cache[32] = _createElementVNode("td", { rowspan: "2" }, "수사지원", -1)),
                  _cache[33] || (_cache[33] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(632, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(633, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(632, $setup.state.data) + $setup.CommonUtils.getCntByCn(633, $setup.state.data))), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[34] || (_cache[34] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(678, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(679, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(678, $setup.state.data) + $setup.CommonUtils.getCntByCn(679, $setup.state.data))), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "법률지원 > 수사지원 > 선임, 서면, 상담, 증거수집")
          ], -1)),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("table", _hoisted_41, [
              _cache[40] || (_cache[40] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "2"
                  }, "구분"),
                  _createElementVNode("th", { width: "15%" }, "선임"),
                  _createElementVNode("th", { width: "15%" }, "서면"),
                  _createElementVNode("th", { width: "15%" }, "상담"),
                  _createElementVNode("th", { width: "15%" }, "증거수집"),
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[37] || (_cache[37] = _createElementVNode("td", { rowspan: "2" }, "수사지원", -1)),
                  _cache[38] || (_cache[38] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(635, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(636, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(637, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(638, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(635, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(636, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(637, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(638, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[39] || (_cache[39] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(681, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(682, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(683, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(684, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(681, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(682, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(683, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(684, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "법률지원 > 소송지원")
          ], -1)),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("table", _hoisted_44, [
              _cache[45] || (_cache[45] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    width: "15%",
                    rowspan: "2",
                    colspan: "2"
                  }, "구분"),
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "2"
                  }, "민사"),
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "2"
                  }, "형사"),
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "2"
                  }, "가사"),
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "2"
                  }, "행정"),
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%",
                    id: "last_th",
                    rowspan: "2"
                  }, "총합")
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "제소"),
                  _createElementVNode("th", null, "피소"),
                  _createElementVNode("th", null, "기소"),
                  _createElementVNode("th", null, "피소"),
                  _createElementVNode("th", null, "제소"),
                  _createElementVNode("th", null, "피소"),
                  _createElementVNode("th", null, "제소"),
                  _createElementVNode("th", null, "피소")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[42] || (_cache[42] = _createElementVNode("td", { rowspan: "2" }, "소송지원", -1)),
                  _cache[43] || (_cache[43] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(645, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(646, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(647, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(648, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(649, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(650, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(651, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(652, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_45, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(645, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(646, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(647, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(648, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(649, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(650, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(651, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(652, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[44] || (_cache[44] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(691, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(692, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(693, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(694, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(695, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(696, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(697, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(698, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_46, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(691, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(692, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(693, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(694, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(695, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(696, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(697, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(698, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _cache[61] || (_cache[61] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "법률지원 > 소송지원")
          ], -1)),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("table", _hoisted_49, [
              _cache[60] || (_cache[60] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "3"
                  }, "구분"),
                  _createElementVNode("th", { width: "15%" }, "선임"),
                  _createElementVNode("th", { width: "15%" }, "재판동행"),
                  _createElementVNode("th", { width: "15%" }, "서면"),
                  _createElementVNode("th", { width: "15%" }, "상담"),
                  _createElementVNode("th", { width: "15%" }, "증거수집"),
                  _createElementVNode("th", {
                    scope: "col",
                    width: "10%",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[47] || (_cache[47] = _createElementVNode("td", { rowspan: "8" }, "소송지원", -1)),
                  _cache[48] || (_cache[48] = _createElementVNode("td", { rowspan: "2" }, "민사", -1)),
                  _cache[49] || (_cache[49] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(654, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(655, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(656, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(657, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(717, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(654, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(655, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(656, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(657, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(717, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[50] || (_cache[50] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(700, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(701, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(702, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(703, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(721, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(700, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(701, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(702, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(703, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(721, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[51] || (_cache[51] = _createElementVNode("td", { rowspan: "2" }, "형사", -1)),
                  _cache[52] || (_cache[52] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(658, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(659, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(660, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(661, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(718, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(658, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(659, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(660, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(661, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(718, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[53] || (_cache[53] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(704, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(705, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(706, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(707, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(722, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(704, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(705, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(706, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(707, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(722, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[54] || (_cache[54] = _createElementVNode("td", { rowspan: "2" }, "가사", -1)),
                  _cache[55] || (_cache[55] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(662, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(663, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(664, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(665, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(719, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(662, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(663, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(664, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(665, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(719, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[56] || (_cache[56] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(708, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(709, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(710, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(711, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(723, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(708, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(709, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(710, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(711, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(723, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[57] || (_cache[57] = _createElementVNode("td", { rowspan: "2" }, "행정", -1)),
                  _cache[58] || (_cache[58] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(666, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(667, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(668, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(669, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(720, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(666, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(667, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(668, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(669, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(720, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[59] || (_cache[59] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(712, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(713, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(714, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(715, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(724, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(712, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(713, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(714, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(715, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(724, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _cache[65] || (_cache[65] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "법률지원 > 소송지원 > 민사")
          ], -1)),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("table", _hoisted_52, [
              _cache[64] || (_cache[64] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "1"
                  }, "구분"),
                  _createElementVNode("th", null, "손해배상"),
                  _createElementVNode("th", null, "채무부존재"),
                  _createElementVNode("th", null, "청구이의"),
                  _createElementVNode("th", null, "개인파산면책"),
                  _createElementVNode("th", null, "부당이익"),
                  _createElementVNode("th", null, "대여금"),
                  _createElementVNode("th", null, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    width: "10%",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[62] || (_cache[62] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1000, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1001, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1002, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1003, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1004, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1005, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1006, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        // CommonUtils.getCntByCn(654, state.data) +
                                        //     CommonUtils.getCntByCn(655, state.data) +
                                        //     CommonUtils.getCntByCn(656, state.data) +
                                        //     CommonUtils.getCntByCn(657, state.data) +
                                        //     CommonUtils.getCntByCn(717, state.data) +
                                        $setup.CommonUtils.getCntByCn(1000, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1001, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1002, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1003, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1004, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1005, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1006, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[63] || (_cache[63] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1100, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1101, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1102, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1103, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1104, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1105, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1106, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        // CommonUtils.getCntByCn(700, state.data) +
                                        //     CommonUtils.getCntByCn(701, state.data) +
                                        //     CommonUtils.getCntByCn(702, state.data) +
                                        //     CommonUtils.getCntByCn(703, state.data) +
                                        //     CommonUtils.getCntByCn(721, state.data) +
                                        $setup.CommonUtils.getCntByCn(1100, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1101, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1102, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1103, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1104, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1105, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1106, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _cache[69] || (_cache[69] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "법률지원 > 소송지원 > 형사")
          ], -1)),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("table", _hoisted_55, [
              _cache[68] || (_cache[68] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    width: "15%",
                    colspan: "1"
                  }, "구분"),
                  _createElementVNode("th", null, "성매매"),
                  _createElementVNode("th", null, "사기"),
                  _createElementVNode("th", null, "성폭행/상해"),
                  _createElementVNode("th", null, "주거침입"),
                  _createElementVNode("th", null, "명예훼손"),
                  _createElementVNode("th", null, "협박"),
                  _createElementVNode("th", null, "아청법"),
                  _createElementVNode("th", null, "디지털성범죄"),
                  _createElementVNode("th", null, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    width: "10%",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[66] || (_cache[66] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1011, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1012, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1013, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1014, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1015, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1016, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1017, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1018, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1019, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(1011, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1012, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1013, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1014, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1015, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1016, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1017, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1018, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1019, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[67] || (_cache[67] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1111, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1112, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1113, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1114, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1115, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1116, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1117, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1118, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1119, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(1111, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1112, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1113, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1114, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1115, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1116, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1117, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1118, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1119, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _cache[73] || (_cache[73] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "의료지원")
          ], -1)),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("table", _hoisted_58, [
              _cache[72] || (_cache[72] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, "건강상담"),
                  _createElementVNode("th", { scope: "col" }, "내과"),
                  _createElementVNode("th", { scope: "col" }, "산부인과"),
                  _createElementVNode("th", { scope: "col" }, "성형외과"),
                  _createElementVNode("th", { scope: "col" }, "안과 / 이비인후과"),
                  _createElementVNode("th", { scope: "col" }, "외과"),
                  _createElementVNode("th", { scope: "col" }, "정신건강의학"),
                  _createElementVNode("th", { scope: "col" }, "치과"),
                  _createElementVNode("th", { scope: "col" }, "피부과"),
                  _createElementVNode("th", { scope: "col" }, "종합건강검진"),
                  _createElementVNode("th", { scope: "col" }, "비뇨기과"),
                  _createElementVNode("th", { scope: "col" }, "한방"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[70] || (_cache[70] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(142, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(156, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(157, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(158, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(159, $setup.state.data) + $setup.CommonUtils.getCntByCn(161, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(160, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(162, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(163, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(164, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(165, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(1165, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(166, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(167, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(142, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(156, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(157, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(158, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(159, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(160, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(161, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(162, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(163, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(164, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(165, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(1165, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(166, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(167, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[71] || (_cache[71] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(427, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(429, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(430, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(431, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(432, $setup.state.data) + $setup.CommonUtils.getCntByCn(434, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(433, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(435, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(436, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(437, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(438, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(462, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(439, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(440, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(427, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(429, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(430, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(431, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(432, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(433, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(434, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(435, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(436, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(437, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(438, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(462, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(439, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(440, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _cache[77] || (_cache[77] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원제공 > 자활지원")
          ], -1)),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("table", _hoisted_61, [
              _cache[76] || (_cache[76] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, "자활상담/정보제공/지원"),
                  _createElementVNode("th", { scope: "col" }, "주거상담/정보제공/지원"),
                  _createElementVNode("th", { scope: "col" }, "자활관련기초검사"),
                  _createElementVNode("th", { scope: "col" }, "직업훈련수당"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[74] || (_cache[74] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(144, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(145, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(146, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(586, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(148, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(144, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(145, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(146, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(586, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(148, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[75] || (_cache[75] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(441, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(442, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(443, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(587, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(444, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(441, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(442, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(443, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(587, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(444, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _cache[81] || (_cache[81] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원제공 > 집단프로그램")
          ], -1)),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("table", _hoisted_64, [
              _cache[80] || (_cache[80] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 치료회복 "),
                    _createElementVNode("br"),
                    _createTextVNode(" 프로그램 ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 수강명령 "),
                    _createElementVNode("br"),
                    _createTextVNode(" 프로그램 ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 열린터 "),
                    _createElementVNode("br"),
                    _createTextVNode(" 프로그램 ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 예비교육 "),
                    _createElementVNode("br"),
                    _createTextVNode(" 프로그램 ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 심리정서 "),
                    _createElementVNode("br"),
                    _createTextVNode(" 프로그램 ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 사회적응 "),
                    _createElementVNode("br"),
                    _createTextVNode(" 프로그램 ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 사각지대 "),
                    _createElementVNode("br"),
                    _createTextVNode(" 프로그램 ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, "문화/체험활동"),
                  _createElementVNode("th", { scope: "col" }, "건강관리/체력강화"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[78] || (_cache[78] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(149, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(150, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(564, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(565, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(571, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(572, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(783, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(573, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(574, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(575, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(149, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(150, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(564, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(565, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(571, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(572, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(783, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(573, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(574, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(575, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[79] || (_cache[79] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(445, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(446, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(566, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(567, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(576, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(577, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(784, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(578, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(579, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(580, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(445, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(446, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(566, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(567, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(576, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(577, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(784, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(578, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(579, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(580, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _cache[85] || (_cache[85] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원제공 > 집단프로그램> 사각지대 프로그램")
          ], -1)),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("table", _hoisted_67, [
              _cache[84] || (_cache[84] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, "사부작공방"),
                  _createElementVNode("th", { scope: "col" }, "사회적응력향상"),
                  _createElementVNode("th", { scope: "col" }, "동료활동"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[82] || (_cache[82] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(748, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(749, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(750, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(748, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(749, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(750, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[83] || (_cache[83] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(752, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(753, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(754, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(752, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(753, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(754, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _cache[89] || (_cache[89] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원제공 > 물적자원")
          ], -1)),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("table", _hoisted_70, [
              _cache[88] || (_cache[88] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, "물품"),
                  _createElementVNode("th", { scope: "col" }, "후원금"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[86] || (_cache[86] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(151, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(152, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(151, $setup.state.data) + $setup.CommonUtils.getCntByCn(152, $setup.state.data))), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[87] || (_cache[87] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(447, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(448, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(447, $setup.state.data) + $setup.CommonUtils.getCntByCn(448, $setup.state.data))), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _cache[93] || (_cache[93] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원연결 > 물적자원")
          ], -1)),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("table", _hoisted_73, [
              _cache[92] || (_cache[92] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, "물품"),
                  _createElementVNode("th", { scope: "col" }, "후원금"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[90] || (_cache[90] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(170, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(171, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(170, $setup.state.data) + $setup.CommonUtils.getCntByCn(171, $setup.state.data))), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[91] || (_cache[91] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(449, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(450, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(449, $setup.state.data) + $setup.CommonUtils.getCntByCn(450, $setup.state.data))), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _cache[97] || (_cache[97] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "서비스/자원연결> 심리지원")
          ], -1)),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("table", _hoisted_76, [
              _cache[96] || (_cache[96] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "15%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, "개별상담"),
                  _createElementVNode("th", { scope: "col" }, "집단상담"),
                  _createElementVNode("th", { scope: "col" }, "임상심리검사"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[94] || (_cache[94] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(168, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(169, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(588, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(168, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(169, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(588, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[95] || (_cache[95] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(451, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(452, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(589, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(451, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(452, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(589, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_77, [
          _cache[101] || (_cache[101] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "타기관의뢰 > 기관유형")
          ], -1)),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("table", _hoisted_79, [
              _cache[100] || (_cache[100] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "10%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, "지원시설"),
                  _createElementVNode("th", { scope: "col" }, "공동생활가정"),
                  _createElementVNode("th", { scope: "col" }, "자활지원센터"),
                  _createElementVNode("th", { scope: "col" }, "직업훈련·알선기관"),
                  _createElementVNode("th", { scope: "col" }, "타(성매매)상담소"),
                  _createElementVNode("th", { scope: "col" }, "대안교육위탁기관"),
                  _createElementVNode("th", { scope: "col" }, "일시쉼터"),
                  _createElementVNode("th", { scope: "col" }, [
                    _createTextVNode(" 전문상담기관 "),
                    _createElementVNode("br"),
                    _createTextVNode(" (성폭·가폭·장애인 등) ")
                  ]),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[98] || (_cache[98] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(172, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(173, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(174, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(175, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(176, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(177, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(178, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(544, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(179, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(172, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(173, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(174, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(175, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(176, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(177, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(178, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(179, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(544, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[99] || (_cache[99] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(453, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(454, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(455, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(456, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(457, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(458, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(459, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(545, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(460, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(453, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(454, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(455, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(456, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(457, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(458, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(459, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(460, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(545, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_80, [
          _cache[105] || (_cache[105] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "타기관의뢰 > 기관유형> 전문상담기관")
          ], -1)),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("table", _hoisted_82, [
              _cache[104] || (_cache[104] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    scope: "col",
                    width: "10%"
                  }, "구분"),
                  _createElementVNode("th", { scope: "col" }, "성폭력"),
                  _createElementVNode("th", { scope: "col" }, "가정폭력"),
                  _createElementVNode("th", { scope: "col" }, "장애인"),
                  _createElementVNode("th", { scope: "col" }, "이주여성"),
                  _createElementVNode("th", { scope: "col" }, "디지털성범죄"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[102] || (_cache[102] = _createElementVNode("td", null, "총실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(756, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(757, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(758, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(759, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(760, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(756, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(757, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(758, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(759, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(760, $setup.state.data),
                                    )), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[103] || (_cache[103] = _createElementVNode("td", null, "구조지원실적", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(762, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(763, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(764, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(765, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(766, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(762, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(763, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(764, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(765, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(766, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_83, [
          _cache[107] || (_cache[107] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "타기관의뢰 > 상담유형")
          ], -1)),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("table", _hoisted_85, [
              _cache[106] || (_cache[106] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "의뢰상담"),
                  _createElementVNode("th", { scope: "col" }, "모니터링 상담"),
                  _createElementVNode("th", { scope: "col" }, "입소"),
                  _createElementVNode("th", { scope: "col" }, "이용자 등록"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_86, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(310, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_87, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(311, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_88, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(312, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_89, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(313, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_90, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(310, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(311, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(312, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(313, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_91, [
          _cache[109] || (_cache[109] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "기타")
          ], -1)),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("table", _hoisted_93, [
              _cache[108] || (_cache[108] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "무응답"),
                  _createElementVNode("th", { scope: "col" }, "연락두절"),
                  _createElementVNode("th", { scope: "col" }, "통화거절"),
                  _createElementVNode("th", { scope: "col" }, "행정"),
                  _createElementVNode("th", { scope: "col" }, "종결"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_94, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(182, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_95, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(183, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_96, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(184, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_97, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(591, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_98, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(770, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_99, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(182, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(183, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(184, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(591, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(770, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_100, [
          _cache[111] || (_cache[111] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성과현황 > 의료지원")
          ], -1)),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("table", _hoisted_102, [
              _cache[110] || (_cache[110] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "치료중단"),
                  _createElementVNode("th", { scope: "col" }, "치료중"),
                  _createElementVNode("th", { scope: "col" }, "완치/증상조절"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_103, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(186, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_104, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(187, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_105, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(188, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_106, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(186, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(187, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(188, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_107, [
          _cache[113] || (_cache[113] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성과현황> 법률지원")
          ], -1)),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("table", _hoisted_109, [
              _cache[112] || (_cache[112] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "승소"),
                  _createElementVNode("th", { scope: "col" }, "패소"),
                  _createElementVNode("th", { scope: "col" }, "보호처분"),
                  _createElementVNode("th", { scope: "col" }, "파산/면책결정"),
                  _createElementVNode("th", { scope: "col" }, "조정/합의"),
                  _createElementVNode("th", { scope: "col" }, "잠정보류"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_110, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(189, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_111, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(190, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_112, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(590, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_113, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(191, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_114, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(192, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_115, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(193, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_116, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(189, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(190, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(590, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(191, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(192, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(193, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_117, [
          _cache[115] || (_cache[115] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성과현황> 자활지원")
          ], -1)),
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("table", _hoisted_119, [
              _cache[114] || (_cache[114] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "자격증취득"),
                  _createElementVNode("th", { scope: "col" }, "검정고시합격"),
                  _createElementVNode("th", { scope: "col" }, "진학"),
                  _createElementVNode("th", { scope: "col" }, "상위학위취득"),
                  _createElementVNode("th", { scope: "col" }, "학원등록"),
                  _createElementVNode("th", { scope: "col" }, "창업"),
                  _createElementVNode("th", { scope: "col" }, "취업(정규직)"),
                  _createElementVNode("th", { scope: "col" }, "취업(비정규직)"),
                  _createElementVNode("th", { scope: "col" }, "취업(일용직)"),
                  _createElementVNode("th", { scope: "col" }, "취업(기타)"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_120, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(194, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_121, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(195, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_122, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(196, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_123, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(197, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_124, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(198, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_125, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(199, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_126, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(200, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_127, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(201, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_128, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(202, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_129, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(203, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_130, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(204, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_131, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(194, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(195, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(196, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(197, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(198, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(199, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(200, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(201, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(202, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(203, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(204, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_132, [
          _cache[117] || (_cache[117] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성과현황 > 자활지원 > 취업 및 진학 현황")
          ], -1)),
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("table", _hoisted_134, [
              _cache[116] || (_cache[116] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "서비스업"),
                  _createElementVNode("th", { scope: "col" }, "생산직"),
                  _createElementVNode("th", { scope: "col" }, "사무직"),
                  _createElementVNode("th", { scope: "col" }, "창업"),
                  _createElementVNode("th", { scope: "col" }, "진학"),
                  _createElementVNode("th", { scope: "col" }, "자격증취득"),
                  _createElementVNode("th", { scope: "col" }, "검정고시합격"),
                  _createElementVNode("th", { scope: "col" }, "상위학위취득"),
                  _createElementVNode("th", { scope: "col" }, "학원등록"),
                  _createElementVNode("th", { scope: "col" }, "진급"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_135, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(534, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_136, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(535, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_137, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(547, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_138, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(199, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_139, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(196, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_140, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(194, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_141, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(195, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_142, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(197, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_143, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(198, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_144, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(785, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_145, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(204, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_146, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(534, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(535, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(547, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(199, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(196, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(194, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(195, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(197, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(198, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(785, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(204, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_147, [
          _cache[119] || (_cache[119] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성과현황 > 자활지원 > 고용형태")
          ], -1)),
          _createElementVNode("div", _hoisted_148, [
            _createElementVNode("table", _hoisted_149, [
              _cache[118] || (_cache[118] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "정규직"),
                  _createElementVNode("th", { scope: "col" }, "비정규직"),
                  _createElementVNode("th", { scope: "col" }, "인턴,실습"),
                  _createElementVNode("th", { scope: "col" }, "단기간근로자"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_150, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(200, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_151, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(201, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_152, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(536, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_153, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(202, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_154, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(203, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_155, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(200, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(201, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(536, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(202, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(203, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_156, [
          _cache[121] || (_cache[121] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "나이")
          ], -1)),
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("table", _hoisted_158, [
              _cache[120] || (_cache[120] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "13세이하"),
                  _createElementVNode("th", { scope: "col" }, "14~16세"),
                  _createElementVNode("th", { scope: "col" }, "17~19세"),
                  _createElementVNode("th", { scope: "col" }, "20~29세"),
                  _createElementVNode("th", { scope: "col" }, "30~39세"),
                  _createElementVNode("th", { scope: "col" }, "40~49세"),
                  _createElementVNode("th", { scope: "col" }, "50~59세"),
                  _createElementVNode("th", { scope: "col" }, "60세이상"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_159, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(205, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_160, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(206, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_161, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(207, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_162, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(208, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_163, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(209, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_164, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(210, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_165, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(211, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_166, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(548, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_167, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(212, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_168, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(205, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(206, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(207, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(208, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(209, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(210, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(211, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(548, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(212, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_169, [
          _cache[123] || (_cache[123] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "만 나이")
          ], -1)),
          _createElementVNode("div", _hoisted_170, [
            _createElementVNode("table", _hoisted_171, [
              _cache[122] || (_cache[122] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "13세이하(만 12세 이하)"),
                  _createElementVNode("th", { scope: "col" }, "14~16세(만 13~15세)"),
                  _createElementVNode("th", { scope: "col" }, "17~19세(만 16~18세)"),
                  _createElementVNode("th", { scope: "col" }, "20~29세(만 19~28세)"),
                  _createElementVNode("th", { scope: "col" }, "30~39세(만 29~38세)"),
                  _createElementVNode("th", { scope: "col" }, "40~49세(만 39~38세)"),
                  _createElementVNode("th", { scope: "col" }, "50~59세(만 49~58세)"),
                  _createElementVNode("th", { scope: "col" }, "60세이상(만 59세 이상)"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_172, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(790, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_173, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(791, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_174, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(792, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_175, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(793, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_176, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(794, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_177, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(795, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_178, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(796, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_179, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(797, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_180, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(798, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_181, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(790, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(791, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(792, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(793, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(794, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(795, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(796, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(797, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(798, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_182, [
          _cache[125] || (_cache[125] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "학력")
          ], -1)),
          _createElementVNode("div", _hoisted_183, [
            _createElementVNode("table", _hoisted_184, [
              _cache[124] || (_cache[124] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "초재"),
                  _createElementVNode("th", { scope: "col" }, "초교중퇴"),
                  _createElementVNode("th", { scope: "col" }, "초교졸"),
                  _createElementVNode("th", { scope: "col" }, "중재"),
                  _createElementVNode("th", { scope: "col" }, "중교중퇴"),
                  _createElementVNode("th", { scope: "col" }, "중교졸"),
                  _createElementVNode("th", { scope: "col" }, "고재"),
                  _createElementVNode("th", { scope: "col" }, "고교중퇴"),
                  _createElementVNode("th", { scope: "col" }, "고교졸"),
                  _createElementVNode("th", { scope: "col" }, "대중퇴"),
                  _createElementVNode("th", { scope: "col" }, "대재"),
                  _createElementVNode("th", { scope: "col" }, "대졸"),
                  _createElementVNode("th", { scope: "col" }, "대학원재"),
                  _createElementVNode("th", { scope: "col" }, "대학원졸"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_185, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(592, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_186, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(593, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_187, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(594, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_188, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(595, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_189, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(596, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_190, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(597, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_191, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(598, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_192, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(599, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_193, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(600, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_194, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(601, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_195, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(602, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_196, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(603, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_197, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(604, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_198, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(605, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_199, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(606, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_200, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(607, $setup.state.data) + $setup.CommonUtils.getCntByCn(608, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_201, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(592, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(593, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(594, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(595, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(596, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(597, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(598, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(599, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(600, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(601, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(602, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(603, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(604, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(605, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(606, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(607, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(608, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_202, [
          _cache[127] || (_cache[127] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "상담경로")
          ], -1)),
          _createElementVNode("div", _hoisted_203, [
            _createElementVNode("table", _hoisted_204, [
              _cache[126] || (_cache[126] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "1366,1388등"),
                  _createElementVNode("th", { scope: "col" }, "117"),
                  _createElementVNode("th", { scope: "col" }, "홍보(인터넷,114,언론보도등)"),
                  _createElementVNode("th", { scope: "col" }, "지인소개"),
                  _createElementVNode("th", { scope: "col" }, "유관기관"),
                  _createElementVNode("th", { scope: "col" }, "성매매방지기관"),
                  _createElementVNode("th", { scope: "col" }, "학교"),
                  _createElementVNode("th", { scope: "col" }, "검찰/경찰/법원"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", { scope: "col" }, "기록없음"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_205, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(609, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_206, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(610, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_207, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(611, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_208, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(612, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_209, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(613, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_210, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(614, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_211, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(615, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_212, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(616, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_213, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(617, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_214, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(618, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_215, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(609, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(610, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(611, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(612, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(613, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(614, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(615, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(616, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(617, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(618, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_216, [
          _cache[130] || (_cache[130] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "성매매유형")
          ], -1)),
          _createElementVNode("div", _hoisted_217, [
            ($setup.state.sYear >= 2019)
              ? (_openBlock(), _createElementBlock("table", _hoisted_218, [
                  _cache[128] || (_cache[128] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" (전업형) "),
                        _createElementVNode("br"),
                        _createTextVNode(" 집결지 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" (전업형) "),
                        _createElementVNode("br"),
                        _createTextVNode(" 오피스텔 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 겸업형 "),
                        _createElementVNode("br"),
                        _createTextVNode(" (기존산업형) ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 위장형 "),
                        _createElementVNode("br"),
                        _createTextVNode(" (기존산업형) ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, "출장형"),
                      _createElementVNode("th", { scope: "col" }, "온라인"),
                      _createElementVNode("th", { scope: "col" }, "해외성매매"),
                      _createElementVNode("th", { scope: "col" }, "기타"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 기록 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 없음 ")
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        id: "last_th"
                      }, "총합")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_219, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(220, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_220, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(621, $setup.state.data) + $setup.CommonUtils.getCntByCn(561, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_221, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.CommonUtils.getCntByCn(221, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(222, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(223, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(227, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(622, $setup.state.data),
                                        )), 1),
                      _createElementVNode("td", _hoisted_222, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(228, $setup.state.data) + $setup.CommonUtils.getCntByCn(623, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_223, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(225, $setup.state.data) + $setup.CommonUtils.getCntByCn(624, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_224, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.CommonUtils.getCntByCn(559, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(560, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(625, $setup.state.data),
                                        )), 1),
                      _createElementVNode("td", _hoisted_225, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(562, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_226, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(226, $setup.state.data) + $setup.CommonUtils.getCntByCn(300, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_227, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(301, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_228, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.CommonUtils.getCntByCn(220, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(621, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(561, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(221, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(222, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(223, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(227, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(622, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(228, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(623, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(225, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(624, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(559, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(560, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(625, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(562, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(226, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(300, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(301, $setup.state.data),
                                        )), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("table", _hoisted_229, [
                  _cache[129] || (_cache[129] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "집결지"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 오피스텔 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, "식품접객업소"),
                      _createElementVNode("th", { scope: "col" }, "위생접객업소"),
                      _createElementVNode("th", { scope: "col" }, "마사지업소"),
                      _createElementVNode("th", { scope: "col" }, "퐁속영업업소"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 변종 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 전자형성매매 "),
                        _createElementVNode("br"),
                        _createTextVNode(" (조건만남)-개인 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 전자형성매매 "),
                        _createElementVNode("br"),
                        _createTextVNode(" (조건만남)-알선 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 길거리 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 출장형 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, "외국인전용클럽"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 해외 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 성매매 ")
                      ]),
                      _createElementVNode("th", { scope: "col" }, "기타"),
                      _createElementVNode("th", { scope: "col" }, [
                        _createTextVNode(" 기록 "),
                        _createElementVNode("br"),
                        _createTextVNode(" 없음 ")
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        id: "last_th"
                      }, "총합")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_230, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(220, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_231, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(561, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_232, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(221, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_233, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(222, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_234, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(223, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_235, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(227, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_236, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(228, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_237, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(559, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_238, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(560, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_239, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(226, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_240, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(225, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_241, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(224, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_242, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(562, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_243, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(300, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_244, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(301, $setup.state.data))), 1),
                      _createElementVNode("td", _hoisted_245, _toDisplayString($setup.CommonUtils.numberFormat(
                                            $setup.CommonUtils.getCntByCn(220, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(561, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(221, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(222, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(223, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(227, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(228, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(559, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(560, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(226, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(225, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(224, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(562, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(300, $setup.state.data) +
                                                $setup.CommonUtils.getCntByCn(301, $setup.state.data),
                                        )), 1)
                    ])
                  ])
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_246, [
          _cache[132] || (_cache[132] = _createElementVNode("div", { class: "area_contents_title" }, [
            _createElementVNode("p", null, "알선고리")
          ], -1)),
          _createElementVNode("div", _hoisted_247, [
            _createElementVNode("table", _hoisted_248, [
              _cache[131] || (_cache[131] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "보도방"),
                  _createElementVNode("th", { scope: "col" }, "소개업자"),
                  _createElementVNode("th", { scope: "col" }, "사채업자"),
                  _createElementVNode("th", { scope: "col" }, "업주"),
                  _createElementVNode("th", { scope: "col" }, "업소관계자"),
                  _createElementVNode("th", { scope: "col" }, "친구,지인"),
                  _createElementVNode("th", { scope: "col" }, "보호자,가족"),
                  _createElementVNode("th", { scope: "col" }, "홍보물"),
                  _createElementVNode("th", { scope: "col" }, "구인구직사이트"),
                  _createElementVNode("th", { scope: "col" }, "채팅앱"),
                  _createElementVNode("th", { scope: "col" }, "기타"),
                  _createElementVNode("th", {
                    scope: "col",
                    id: "last_th"
                  }, "총합")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_249, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(771, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_250, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(772, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_251, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(773, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_252, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(774, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_253, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(775, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_254, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(776, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_255, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(777, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_256, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(778, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_257, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(779, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_258, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(780, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_259, _toDisplayString($setup.CommonUtils.numberFormat($setup.CommonUtils.getCntByCn(781, $setup.state.data))), 1),
                  _createElementVNode("td", _hoisted_260, _toDisplayString($setup.CommonUtils.numberFormat(
                                        $setup.CommonUtils.getCntByCn(771, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(772, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(773, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(774, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(775, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(776, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(777, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(778, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(779, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(780, $setup.state.data) +
                                            $setup.CommonUtils.getCntByCn(781, $setup.state.data),
                                    )), 1)
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_261))
}